import { startAuthentication, startRegistration, browserSupportsWebAuthn } from "@simplewebauthn/browser";
import api from "@/lib/api";

export const passkeysSupported = () => browserSupportsWebAuthn();

/** Friendly copy for the errors the WebAuthn spec throws at us. */
export const passkeyError = (err) => {
  if (err?.name === "NotAllowedError") return "Face ID was cancelled or timed out.";
  if (err?.name === "InvalidStateError") return "This device is already set up for Face ID sign-in.";
  if (err?.name === "NotSupportedError") return "This device doesn't support Face ID sign-in.";
  return err?.response?.data?.detail || err?.message || "Something went wrong.";
};

// The ingress rewrites the Origin header, so we tell the backend which origin the
// ceremony is really running on — the browser enforces it matches this page.
const here = () => ({ origin: window.location.origin });

/** Enrol the current device. Requires an authenticated session. */
export const enrolPasskey = async (label) => {
  const { data: options } = await api.post("/webauthn/register/options", here());
  const credential = await startRegistration({ optionsJSON: options });
  const { data } = await api.post("/webauthn/register/verify", { credential, label, ...here() });
  return data.credential;
};

/** Sign in with a passkey. No email needed — the device offers its saved accounts. */
export const loginWithPasskey = async () => {
  const { data: options } = await api.post("/webauthn/login/options", here());
  const credential = await startAuthentication({ optionsJSON: options });
  const { data } = await api.post("/webauthn/login/verify", { credential, ...here() });
  return data.user;
};

/** Approve one sensitive action (an order) with Face ID. Returns a one-time token. */
export const stepUpApprove = async (purpose, payload = {}) => {
  const { data: options } = await api.post("/webauthn/step-up/options",
    { purpose, payload, ...here() });
  const credential = await startAuthentication({ optionsJSON: options });
  const { data } = await api.post("/webauthn/step-up/verify",
    { credential, purpose, ...here() });
  return data.approval_token;
};
